import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Facet } from '../../types/facet.interface';
import { isMobile } from 'react-device-detect';
import Button from '../button/button.component';
import styles from './facets.module.scss';

type Props = {
  facets: Facet;
  initialValues: { [key: string]: string[] | string };
  type: 'finds' | 'loci';
  customOnSubmit?: (values: { [key: string]: string[] | string }) => void;
  horizontal?: boolean;
  baseFacets: Facet;
  q?: string;
};

const Facets = ({
  facets,
  initialValues,
  type,
  customOnSubmit,
  horizontal,
  baseFacets,
  q,
}: Props) => {
  const [open, setOpen] = useState<{ [key: string]: boolean }>();
  useEffect(() => {
    const currentOpen: { [key: string]: boolean } = {};
    Object.keys(baseFacets).forEach(
      (facet) => (currentOpen[facet] = !isMobile)
    );
    setOpen(currentOpen);
  }, [baseFacets]);
  const router = useRouter();
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      if (customOnSubmit) {
        customOnSubmit(values);
      } else {
        router.push({
          pathname: `/${type}/search/results`,
          query: q ? { ...values, q } : values,
        });
      }
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        formik.handleSubmit(e);
      }}
      className={horizontal ? styles.formHorizontal : ''}
    >
      {Object.keys(baseFacets).map((facet, i) => {
        const currentFacets = baseFacets[facet];
        return (
          <div
            className={
              horizontal ? styles.facetWrapperBlock : styles.facetWrapper
            }
            key={`${facet}-${i}`}
          >
            <a
              href="#"
              className={styles.facetGroupName}
              onClick={() => {
                const current = { ...open };
                current[facet] = !current[facet];
                setOpen(current);
              }}
            >
              <span>
                {facet.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase()}
              </span>
              <FontAwesomeIcon
                icon={open && open[facet] ? faCaretUp : faCaretDown}
              />
            </a>
            <ul
              style={{
                height:
                  open && open[facet]
                    ? 24 * Object.keys(currentFacets).length + 24
                    : 0,
                transition: 'all 0.5s',
                overflowY: 'auto',
              }}
            >
              {Object.keys(currentFacets).map((currentFacet, j) => {
                return (
                  <li key={`${facet}-${i}-${j}`}>
                    <label className={styles.facet}>
                      <input
                        type="checkbox"
                        name={facet}
                        value={currentFacet}
                        defaultChecked={
                          initialValues[facet]
                            ? Array.isArray(initialValues[facet])
                              ? initialValues[facet].includes(currentFacet)
                              : initialValues[facet] === currentFacet
                            : undefined
                        }
                        onChange={async (e) => {
                          formik.handleChange(e);
                          if (customOnSubmit) {
                            await formik.submitForm();
                          }
                        }}
                      />
                      <span className={styles.facetLabel}>
                        {currentFacet.replace('_', '')}
                      </span>
                      <span className={styles.facetCount}>
                        {facets[facet][currentFacet] || 0}
                      </span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
      {formik.dirty && !customOnSubmit && (
        <div className={styles.buttonWrapper}>
          <Button btn={true} type="submit" small={true}>
            Search
          </Button>
        </div>
      )}
    </form>
  );
};

export default Facets;
